import {
  Component,
  DestroyRef,
  inject,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store as NgrxStore } from '@ngrx/store';
import { getNavbarState } from '@fc-store/selectors/ui.selector';
import { getCurrentCustomer } from '@fc-store/selectors/current-customer.selector';
import { NavigationComponent } from '@fc-core/navbar/navigation/navigation.component';
import { HeaderComponent } from '@fc-core/components/header/header.component';
import { PaymentNotificationComponent } from '@fc-core/components/payment-notification';
import { RouterModule } from '@angular/router';
import { QuickSearchFacadeService } from '@fc-search/services/quick-search-facade.service';
import { CoreUIStore } from 'src/app/store/core-ui.store';

@Component({
  selector: 'fc-internal-app',
  imports: [
    NavigationComponent,
    HeaderComponent,
    RouterModule,
    PaymentNotificationComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (pastDueCustomer(); as customer) {
      <fc-payment-notification [customer]="customer" />
    }
    <div class="flex h-full w-full">
      <fc-navigation />
      <div
        class="flex flex-col flex-1 w-full md:w-auto overflow-hidden print:overflow-visible print:h-auto"
      >
        <fc-header
          [class.hidden]="!uiStore.selectors.headerShown()"
          class="print:hidden"
        />
        <div
          class="flex-1 overflow-auto bg-secondary-50 print:overflow-visible print:h-auto"
        >
          <router-outlet />
        </div>
      </div>
    </div>
  `,
})
export class InternalAppComponent {
  readonly ngrxStore = inject(NgrxStore);
  readonly uiStore = inject(CoreUIStore);
  readonly navbarState = this.ngrxStore.selectSignal(getNavbarState);
  private readonly currentCustomer =
    this.ngrxStore.selectSignal(getCurrentCustomer);
  readonly pastDueCustomer = computed(() => {
    const customer = this.currentCustomer();
    return customer && customer.paymentStatus !== 'active-current'
      ? customer
      : null;
  });

  constructor() {
    const facade = inject(QuickSearchFacadeService);
    const destroyRef = inject(DestroyRef);
    document.addEventListener('keydown', facade.onGlobalKeyDown, true);
    destroyRef.onDestroy(() =>
      document.removeEventListener('keydown', facade.onGlobalKeyDown, true),
    );
  }
}
